module.exports = __webpack_public_path__ + "img/43_84.54521284.png";